import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskAssessmentsOverviewStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
        },
        chipContainer: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
        },
        // The linked-risk chip is the entity graph's entry point, so the whole chip + triangle group is clickable.
        linkedRiskTileValue: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            cursor: "pointer",
        },
    });
};
